import { ListSpecialitesComponent } from "./specialites/list-specialites/list-specialites.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomePageOneComponent } from "./components/pages/home-page-one/home-page-one.component";
import { HomePageTwoComponent } from "./components/pages/home-page-two/home-page-two.component";
import { HomePageThreeComponent } from "./components/pages/home-page-three/home-page-three.component";
import { HomePageFourComponent } from "./components/pages/home-page-four/home-page-four.component";
import { HomePageFiveComponent } from "./components/pages/home-page-five/home-page-five.component";
import { HomePageSixComponent } from "./components/pages/home-page-six/home-page-six.component";
import { HomePageSevenComponent } from "./components/pages/home-page-seven/home-page-seven.component";
import { AboutPageOneComponent } from "./components/pages/about-page-one/about-page-one.component";
import { AboutPageTwoComponent } from "./components/pages/about-page-two/about-page-two.component";
import { InstructorsPageOneComponent } from "./components/pages/instructors-page-one/instructors-page-one.component";
import { InstructorsPageTwoComponent } from "./components/pages/instructors-page-two/instructors-page-two.component";
import { InstructorsPageThreeComponent } from "./components/pages/instructors-page-three/instructors-page-three.component";
import { InstructorsDetailsPageComponent } from "./components/pages/instructors-details-page/instructors-details-page.component";
import { EventsPageComponent } from "./components/pages/events-page/events-page.component";
import { EventsDetailsPageComponent } from "./components/pages/events-details-page/events-details-page.component";
import { GalleryPageComponent } from "./components/pages/gallery-page/gallery-page.component";
import { PricingPageComponent } from "./components/pages/pricing-page/pricing-page.component";
import { FeedbackPageComponent } from "./components/pages/feedback-page/feedback-page.component";
import { PartnerPageComponent } from "./components/pages/partner-page/partner-page.component";
// import { LoginPageComponent } from './components/pages/login-page/login-page.component';
// import { RegisterPageComponent } from './components/pages/register-page/register-page.component';
import { FaqPageComponent } from "./components/pages/faq-page/faq-page.component";
import { ErrorPageComponent } from "./components/pages/error-page/error-page.component";
import { ComingSoonPageComponent } from "./components/pages/coming-soon-page/coming-soon-page.component";
import { BlogGridPageComponent } from "./components/pages/blog-grid-page/blog-grid-page.component";
import { BlogRightSidebarPageComponent } from "./components/pages/blog-right-sidebar-page/blog-right-sidebar-page.component";
import { BlogFullWidthPageComponent } from "./components/pages/blog-full-width-page/blog-full-width-page.component";
import { BlogDetailsPageComponent } from "./components/pages/blog-details-page/blog-details-page.component";
import { ShopGridPageComponent } from "./components/pages/shop-grid-page/shop-grid-page.component";
import { ShopFullWidthPageComponent } from "./components/pages/shop-full-width-page/shop-full-width-page.component";
import { ProductsDetailsPageComponent } from "./components/pages/products-details-page/products-details-page.component";
import { CartPageComponent } from "./components/pages/cart-page/cart-page.component";
import { CheckoutPageComponent } from "./components/pages/checkout-page/checkout-page.component";
import { ContactPageComponent } from "./components/pages/contact-page/contact-page.component";
import { CategoryPageOneComponent } from "./components/pages/category-page-one/category-page-one.component";
import { CategoryPageTwoComponent } from "./components/pages/category-page-two/category-page-two.component";
import { CategoryPageThreeComponent } from "./components/pages/category-page-three/category-page-three.component";
import { CoursesListPageComponent } from "./components/pages/courses-list-page/courses-list-page.component";
import { CoursesGridStyleOneColumnsTwoPageComponent } from "./components/pages/courses-grid-style-one-columns-two-page/courses-grid-style-one-columns-two-page.component";
import { CoursesGridStyleOneColumnsThreePageComponent } from "./components/pages/courses-grid-style-one-columns-three-page/courses-grid-style-one-columns-three-page.component";
import { CoursesGridStyleOneColumnsFourPageComponent } from "./components/pages/courses-grid-style-one-columns-four-page/courses-grid-style-one-columns-four-page.component";
import { CoursesGridStyleTwoColumnsTwoPageComponent } from "./components/pages/courses-grid-style-two-columns-two-page/courses-grid-style-two-columns-two-page.component";
import { CoursesGridStyleTwoColumnsThreePageComponent } from "./components/pages/courses-grid-style-two-columns-three-page/courses-grid-style-two-columns-three-page.component";
import { CoursesGridStyleTwoColumnsFourPageComponent } from "./components/pages/courses-grid-style-two-columns-four-page/courses-grid-style-two-columns-four-page.component";
import { CoursesGridStyleThreeColumnsFourPageComponent } from "./components/pages/courses-grid-style-three-columns-four-page/courses-grid-style-three-columns-four-page.component";
import { CoursesGridStyleThreeColumnsThreePageComponent } from "./components/pages/courses-grid-style-three-columns-three-page/courses-grid-style-three-columns-three-page.component";
import { CoursesGridStyleThreeColumnsTwoPageComponent } from "./components/pages/courses-grid-style-three-columns-two-page/courses-grid-style-three-columns-two-page.component";
import { CoursesDetailsPageComponent } from "./components/pages/courses-details-page/courses-details-page.component";
import { MyDashboardPageComponent } from "./components/pages/my-dashboard-page/my-dashboard-page.component";
import { OrdersPageComponent } from "./components/pages/orders-page/orders-page.component";
import { DownloadsPageComponent } from "./components/pages/downloads-page/downloads-page.component";
import { EditAddressPageComponent } from "./components/pages/edit-address-page/edit-address-page.component";
import { EditAccountPageComponent } from "./components/pages/edit-account-page/edit-account-page.component";
import { EditBillingAddressPageComponent } from "./components/pages/edit-billing-address-page/edit-billing-address-page.component";
import { EditShippingAddressPageComponent } from "./components/pages/edit-shipping-address-page/edit-shipping-address-page.component";

import { DespreNoiComponent } from "./despre-noi/despre-noi.component";
import { ContactComponent } from "./contact/contact.component";
import { CoronavirusComponent } from "./coronavirus/coronavirus.component";
import { LoginComponent } from "./login/login.component";
import { HomeComponent } from "./home/home.component";
import { MasuriAccesClinicaComponent } from "./masuri-acces-clinica/masuri-acces-clinica.component";
import { InformatiiAccesServiciiComponent } from "./informatii-acces-servicii/informatii-acces-servicii.component";
import { ContulMeuComponent } from "./contul-meu/contul-meu.component";
import { ProgramariListComponent } from "./programari/programari-list/programari-list.component";
import { MediciListComponent } from "./medici/medici-list/medici-list.component";
import { MediciDetailComponent } from "./medici/medici-detail/medici-detail.component";
import { ShowSpecialtyComponent } from "./specialites/show-specialty/show-specialty.component";
import { ListPricesComponent } from "./prices/list-prices/list-prices.component";
import { ListSettledServicesComponent } from "./prices/list-settled-services/list-settled-services.component";
import { ProgramariResultsComponent } from "./programari/programari-results/programari-results.component";
import { NewsListComponent } from "./news/news-list/news-list.component";
import { NewsDetailComponent } from "./news/news-detail/news-detail.component";
import { ListCareersComponent } from "./careers/list-careers/list-careers.component";
import { DetailCareersComponent } from "./careers/detail-careers/detail-careers.component";

import { AuthGuardService } from "./auth/auth-guard.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from "./auth/token.interceptor";
import { MyTicketsComponent } from "./my-tickets/my-tickets.component";
import { MyPrescriptionsComponent } from "./my-prescriptions/my-prescriptions.component";
import { MyResultsComponent } from "./my-results/my-results.component";
import { ProgramariAddComponent } from "./programari/programari-add/programari-add.component";
import { DrepturiSiObligatiiComponent } from "./drepturi-si-obligatii/drepturi-si-obligatii.component";
import { AchizitiiSiLicitatiiComponent } from "./achizitii-si-licitatii/achizitii-si-licitatii.component";
import { RegisterComponent } from "./register/register.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { DrepturiSalarialeComponent } from "./drepturi-salariale/drepturi-salariale.component";
import { ServiciiPentruPacientiComponent } from "./servicii-pentru-pacienti/servicii-pentru-pacienti.component";
import { CreareContComponent } from "./creare-cont/creare-cont.component";
import { PreventieSiStilDeViataSanatosComponent } from "./preventie-si-stil-de-viata-sanatos/preventie-si-stil-de-viata-sanatos.component";
import { LegislatieComponent } from "./legislatie/legislatie.component";
import { FormularDeEvaluareComponent } from "./formular-de-evaluare/formular-de-evaluare.component";
import { ConducereSiAccesComponent } from "./conducere-si-acces/conducere-si-acces.component";
import { AccessMassMediaComponent } from "./access-mass-media/access-mass-media.component";
import { DeclaratiiDeAvereSiIntereseComponent } from "./declaratii-de-avere-si-interese/declaratii-de-avere-si-interese.component";
import { AdaugaBiletComponent } from "./adauga-bilet/adauga-bilet.component";
import { TemplateRadiologieComponent } from "./template-radiologie/template-radiologie.component";
import { LegislatieCadreMedicaleComponent } from "./legislatie-cadre-medicale/legislatie-cadre-medicale.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { SharedResultComponent } from "./shared-result/shared-result.component";

const routes: Routes = [
    // { path: "course-portal-online", component: HomePageTwoComponent },
    // { path: "distant-learning", component: HomePageThreeComponent },
    // { path: "modern-teaching", component: HomePageFourComponent },
    // { path: "online-schooling", component: HomePageFiveComponent },
    // { path: "learning-school-online", component: HomePageSixComponent },
    // { path: "remote-training-online", component: HomePageSevenComponent },
    // { path: "about-style-1", component: AboutPageOneComponent },
    // { path: "about-style-2", component: AboutPageTwoComponent },
    // { path: "instructor-1", component: InstructorsPageOneComponent },
    // { path: "instructor-2", component: InstructorsPageTwoComponent },
    // { path: "instructor-3", component: InstructorsPageThreeComponent },
    // { path: "single-instructor", component: InstructorsDetailsPageComponent },
    // { path: "gallery", component: GalleryPageComponent },
    // { path: "events", component: EventsPageComponent },
    // { path: "single-events", component: EventsDetailsPageComponent },
    // { path: "pricing", component: PricingPageComponent },
    // { path: "feedback", component: FeedbackPageComponent },
    // { path: "partner", component: PartnerPageComponent },
    // //  {path: 'login', component: LoginPageComponent},
    // //   {path: 'register', component: RegisterPageComponent},
    // { path: "faqs", component: FaqPageComponent },
    // { path: "error-404", component: ErrorPageComponent },
    // { path: "coming-soon", component: ComingSoonPageComponent },
    // { path: "courses-category-style-1", component: CategoryPageOneComponent },
    // { path: "courses-category-style-2", component: CategoryPageTwoComponent },
    // { path: "courses-category-style-3", component: CategoryPageThreeComponent },
    // { path: "courses-list", component: CoursesListPageComponent },
    // {
    //     path: "courses-2-columns-style-1",
    //     component: CoursesGridStyleOneColumnsTwoPageComponent,
    // },
    // {
    //     path: "courses-3-columns-style-1",
    //     component: CoursesGridStyleOneColumnsThreePageComponent,
    // },
    // {
    //     path: "courses-4-columns-style-1",
    //     component: CoursesGridStyleOneColumnsFourPageComponent,
    // },
    // {
    //     path: "courses-2-columns-style-2",
    //     component: CoursesGridStyleTwoColumnsTwoPageComponent,
    // },
    // {
    //     path: "courses-3-columns-style-2",
    //     component: CoursesGridStyleTwoColumnsThreePageComponent,
    // },
    // {
    //     path: "courses-4-columns-style-2",
    //     component: CoursesGridStyleTwoColumnsFourPageComponent,
    // },
    // {
    //     path: "courses-2-columns-style-3",
    //     component: CoursesGridStyleThreeColumnsTwoPageComponent,
    // },
    // {
    //     path: "courses-3-columns-style-3",
    //     component: CoursesGridStyleThreeColumnsThreePageComponent,
    // },
    // {
    //     path: "courses-4-columns-style-3",
    //     component: CoursesGridStyleThreeColumnsFourPageComponent,
    // },
    // { path: "single-courses", component: CoursesDetailsPageComponent },
    // { path: "my-dashboard", component: MyDashboardPageComponent },
    // { path: "orders", component: OrdersPageComponent },
    // { path: "downloads", component: DownloadsPageComponent },
    // { path: "edit-address", component: EditAddressPageComponent },
    // { path: "edit-account", component: EditAccountPageComponent },
    // {
    //     path: "edit-billing-address",
    //     component: EditBillingAddressPageComponent,
    // },
    // {
    //     path: "edit-shipping-address",
    //     component: EditShippingAddressPageComponent,
    // },
    // { path: "blog-style-1", component: BlogGridPageComponent },
    // { path: "blog-style-2", component: BlogRightSidebarPageComponent },
    // { path: "blog-style-3", component: BlogFullWidthPageComponent },
    // { path: "single-blog", component: BlogDetailsPageComponent },
    // { path: "shop-grid", component: ShopGridPageComponent },
    // { path: "shop-grid-fullwidth", component: ShopFullWidthPageComponent },
    // { path: "single-products", component: ProductsDetailsPageComponent },
    // { path: "cart", component: CartPageComponent },
    // { path: "checkout", component: CheckoutPageComponent },
    // { path: "contact-page", component: ContactPageComponent },

    // { path: "", component: HomeComponent },

    // { path: "contact", component: ContactComponent },
    // { path: "despre-noi", component: DespreNoiComponent },
    // // {path: 'cariere', component: CariereComponent},
    // { path: "coronavirus", component: CoronavirusComponent },
    // { path: "specialitati-medicale", component: ListSpecialitesComponent },
    // {
    //     path: "specialitati-medicale/:friendlyUrl",
    //     component: ShowSpecialtyComponent,
    // },
    // { path: "tarife-servicii", component: ListPricesComponent },
    // { path: "servicii-decontate", component: ListSettledServicesComponent },

    // { path: "masuri-acces-clinica", component: MasuriAccesClinicaComponent },
    // {
    //     path: "informatii-acces-servicii",
    //     component: InformatiiAccesServiciiComponent,
    // },
    // { path: "echipa", component: MediciListComponent },
    // { path: "echipa/medic/:friendlyUrl", component: MediciDetailComponent },
    // { path: "anunturi", component: NewsListComponent },
    // { path: "anunturi/anunt/:id", component: NewsDetailComponent },
    // { path: "cariere", component: ListCareersComponent },
    // { path: "cariere/cariera/:id", component: DetailCareersComponent },
    // { path: "drepturi-si-obligatii", component: DrepturiSiObligatiiComponent },
    // {
    //     path: "achizitii-si-licitatii",
    //     component: AchizitiiSiLicitatiiComponent,
    // },
    // { path: "access-mass-media", component: AccessMassMediaComponent },
    // {
    //     path: "declaratii-de-avere-si-interese",
    //     component: DeclaratiiDeAvereSiIntereseComponent,
    // },

    // {
    //     path: "servicii-pentru-pacienti",
    //     component: ServiciiPentruPacientiComponent,
    // },
    // { path: "creare-cont", component: CreareContComponent },
    // {
    //     path: "preventie-si-stil-de-viata-sanatos",
    //     component: PreventieSiStilDeViataSanatosComponent,
    // },
    // { path: "legislatie", component: LegislatieComponent },
    // { path: "formular-de-evaluare", component: FormularDeEvaluareComponent },
    // //{ path: 'conducere-si-acces', component: ConducereSiAccesComponent},

    // { path: "preview", component: ProgramariResultsComponent },

    // { path: "contact", component: ContactComponent },
    // { path: "despre-noi", component: DespreNoiComponent },
    // {
    //     path: "situatie-drepturi-salariale",
    //     component: DrepturiSalarialeComponent,
    // },
    // // {path: 'cariere', component: CariereComponent},
    // { path: "coronavirus", component: CoronavirusComponent },
    // { path: "specialitati-medicale", component: ListSpecialitesComponent },
    // {
    //     path: "specialitati-medicale/:friendlyUrl",
    //     component: ShowSpecialtyComponent,
    // },
    // { path: "tarife-servicii", component: ListPricesComponent },
    // { path: "servicii-decontate", component: ListSettledServicesComponent },
    // { path: "login", component: LoginComponent },
    // { path: "masuri-acces-clinica", component: MasuriAccesClinicaComponent },
    // {
    //     path: "informatii-acces-servicii",
    //     component: InformatiiAccesServiciiComponent,
    // },
    // { path: "echipa", component: MediciListComponent },
    // { path: "echipa/medic/:friendlyUrl", component: MediciDetailComponent },
    // { path: "anunturi", component: NewsListComponent },
    // { path: "anunturi/anunt/:id", component: NewsDetailComponent },
    // { path: "cariere", component: ListCareersComponent },
    // { path: "cariere/cariera/:id", component: DetailCareersComponent },
    // { path: "drepturi-si-obligatii", component: DrepturiSiObligatiiComponent },
    // {
    //     path: "achizitii-si-licitatii",
    //     component: AchizitiiSiLicitatiiComponent,
    // },
    // {
    //     path: "legislatie-cadre-medicale",
    //     component: LegislatieCadreMedicaleComponent,
    // },
    // { path: "politica-gdpr", component: PrivacyPolicyComponent },
    // { path: "template-radiologie", component: TemplateRadiologieComponent },

    { path: "login", component: LoginComponent },
    { path: "register", component: RegisterComponent },
    { path: "forgot-password", component: ForgotPasswordComponent },
    {
        path: "adauga-bilet",
        canActivate: [AuthGuardService],
        component: AdaugaBiletComponent,
    },

    { path: "preview", component: ProgramariResultsComponent },
    {
        path: "contul-meu",
        canActivate: [AuthGuardService],
        component: ContulMeuComponent,
    },

    {
        path: "",
        canActivate: [AuthGuardService],
        component: ContulMeuComponent,
    },

    {
        path: "programari",
        canActivate: [AuthGuardService],
        component: ProgramariListComponent,
    },
    {
        path: "biletele-mele",
        canActivate: [AuthGuardService],
        component: MyTicketsComponent,
    },
    {
        path: "documentele-mele",
        canActivate: [AuthGuardService],
        component: MyPrescriptionsComponent,
    },
    {
        path: "rezultatele-mele",
        canActivate: [AuthGuardService],
        component: MyResultsComponent,
    },
    {
    path: 'result',
    component: SharedResultComponent
},
    {
        path: "efectueaza-programare",
        canActivate: [AuthGuardService],
        component: ProgramariAddComponent,
    },

    { path: "**", component: ErrorPageComponent },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" }),
    ],
    exports: [RouterModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        AuthGuardService,
    ],
})
export class AppRoutingModule {}
